import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformPreview = () => {
  const platformComponents = [
    {
      title: 'Vendor Application',
      description: 'Complete business management for service providers',
      features: ['Booking management', 'Payment processing', 'Customer insights', 'Business analytics'],
      icon: 'Store',
      color: 'accent',
    },
    {
      title: 'Customer Application',
      description: 'Discover and book trusted local services',
      features: ['Service discovery', 'Real-time booking', 'Secure payments', 'Reviews & ratings'],
      icon: 'Smartphone',
      color: 'secondary',
    },
    {
      title: 'Admin Dashboard',
      description: 'Full marketplace oversight and operations',
      features: ['Market analytics', 'Vendor management', 'Payment reconciliation', 'Compliance tools'],
      icon: 'LayoutDashboard',
      color: 'primary',
    },
  ];

  const techStack = [
    { name: 'Azure', description: 'Cloud infrastructure' },
    { name: 'Stripe Connect', description: 'Payment processing' },
    { name: 'Supabase', description: 'Real-time database' },
    { name: 'AI Engine', description: 'Recommendations' },
  ];

  return (
    <section className="py-24 bg-muted">
      <div className="max-w-wide mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-medium text-accent uppercase tracking-wider mb-3">
            Platform
          </p>
          <h2 className="text-display text-foreground mb-6">
            Unified Marketplace Infrastructure
          </h2>
          <p className="text-body-large">
            A complete ecosystem connecting service providers, customers, and partners
            through seamlessly integrated applications.
          </p>
        </div>

        {/* Platform Components */}
        <div className="grid lg:grid-cols-3 gap-6 mb-16">
          {platformComponents.map((component, index) => (
            <div
              key={index}
              className="bg-white rounded-brand-lg p-8 border border-border hover:shadow-corporate-md transition-all duration-300"
            >
              <div className={`w-14 h-14 bg-${component.color}/10 rounded-brand flex items-center justify-center mb-6`}>
                <Icon name={component.icon} size={28} className={`text-${component.color}`} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {component.title}
              </h3>
              <p className="text-muted-foreground mb-6">
                {component.description}
              </p>
              <ul className="space-y-3">
                {component.features.map((feature, i) => (
                  <li key={i} className="flex items-center text-sm text-foreground">
                    <Icon name="Check" size={16} className="text-accent mr-3 flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Tech Stack */}
        <div className="bg-white rounded-brand-lg p-8 border border-border">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Enterprise-Grade Technology
              </h3>
              <p className="text-muted-foreground">
                Built on proven infrastructure trusted by leading companies worldwide.
              </p>
            </div>
            <div className="flex flex-wrap gap-6">
              {techStack.map((tech, index) => (
                <div key={index} className="text-center">
                  <div className="text-sm font-medium text-foreground">{tech.name}</div>
                  <div className="text-xs text-muted-foreground">{tech.description}</div>
                </div>
              ))}
            </div>
            <a
              href="/technology"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-white font-medium rounded-brand-sm hover:bg-primary-light transition-colors whitespace-nowrap"
            >
              View Technology
              <Icon name="ArrowRight" size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformPreview;
